import { GrChip, GrMenuItem } from "@jnpmedi/grebob";
import { MvnMessage } from "@newLibs/utils";
import { notify } from "@newHooks/context/snackbar/notify";
import { BILLING_FUNCTIONALITY_CODE } from "@maven-msg/code/billing";
import { DOCS_DOCUMENT_LANG, DOCS_FOLDER_LANG } from "@maven-msg/lang/docs";

export const MAX_FOLDER_COUNT = 10;

export function useArchiverAddDropdown({
  folderCount,
  isDocsArchiverViewerSubscribe,
  openCreateFolderDialog,
  openCreateDocumentDialog,
}: {
  folderCount: number;
  isDocsArchiverViewerSubscribe: boolean;
  openCreateFolderDialog: { onTrue: () => void };
  openCreateDocumentDialog: { onTrue: () => void };
}): GrMenuItem[] {
  return [
    {
      type: "item",
      text: MvnMessage(DOCS_FOLDER_LANG.DOCS_FOLDER_ADD_DIALOG_HEADER),
      icon: { type: "folder", color: "grey070" },
      onClick: openCreateFolderDialog.onTrue,
      disabled: folderCount >= MAX_FOLDER_COUNT,
    },
    {
      type: "item",
      text: MvnMessage(DOCS_DOCUMENT_LANG.DOCUMENT_UPLOAD_FILE_DIALOG_HEADER),
      children: !isDocsArchiverViewerSubscribe && (
        <GrChip variant="solid" shape="circle" label="Standard + Archiver Plan" size="small" color="orange" />
      ),
      icon: { type: "file-text", color: "grey070" },
      onClick: () => {
        if (!isDocsArchiverViewerSubscribe) {
          notify(MvnMessage(BILLING_FUNCTIONALITY_CODE.BILLING_FUNCTIONALITY_NOT_SUBSCRIBED), "WARN");
          window.open(`${process.env.REACT_APP_AUTH_FE_URL}/subscription/maven-docs`);
          return;
        }
        openCreateDocumentDialog.onTrue();
      },
    },
  ];
}
